module.exports = __webpack_public_path__ + "static/media/pata-green.00a1421f.svg";